import { ARTICLE_CATEGORIES, CATEGORY_LABELS } from "../../types/article";
import type { ArticleCategory } from "../../types/article";

interface CategoryDropdownProps {
  value: ArticleCategory | "";
  onChange: (value: ArticleCategory) => void;
}

export function CategoryDropdown({ value, onChange }: CategoryDropdownProps) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as ArticleCategory)}
      className={`flex-1 h-[51px] px-4 rounded-2xl border border-stroke-primary bg-bg-primary text-base appearance-none cursor-pointer focus:outline-none focus:border-brand-brown ${
        value ? "text-text-primary" : "text-text-tertiary"
      }`}
    >
      <option value="" disabled>
        Select Category
      </option>
      {ARTICLE_CATEGORIES.map((cat) => (
        <option key={cat} value={cat}>
          {CATEGORY_LABELS[cat]}
        </option>
      ))}
    </select>
  );
}
